module.exports = __webpack_public_path__ + "static/media/ke.ac8b7d81.svg";